import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Dropdown2, useThemeMode } from '../../_metronic/partials'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Tooltip } from 'react-tooltip'
import { useParams, useNavigate } from 'react-router-dom'
import { HelpDrawer } from '../../_metronic/partials/layout/help-drawer/HelpDrawer'
import { Dropdown1 } from './Dropdown1'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import userReadableISPPMap from '../static/userReadableISPPMap.json'
import categoryMap from '../static/categoryMap.json'
import isppDescriptions from '../static/isppDescriptions.json'
import Modal from '../components/Modal'
import ViolinPlot from '../components/Plotly'
const GeneSearchPage = () => {
  const theme = useThemeMode()
  const { gene } = useParams() // URL'den gelen gene parametresi
  const navigate = useNavigate() // Yönlendirme için kullanılıyor
  const serviceUrl = process.env.REACT_APP_VAMPPSCORE_BACKEND_BASE_URL || ''
  const [geneData, setGeneData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [geneDetails, setGeneDetails] = useState(null)
  const [violinData, setViolinData] = useState(null)
  const [selectedISPP, setSelectedISPP] = useState(null)
  const [selectedTab, setSelectedTab] = useState(0)
  const [sortBy, setSortBy] = useState(1)
  const [plotError, setPlotError] = useState(null)
  const [hidenegative, setHidenegative] = useState(false)
  const [categorizedGeneData, setCategorizedGeneData] = useState(null)
  const [bestIspps, setBestIspps] = useState([])
  const [sortStates, setSortStates] = useState({
    ISPP: 0,
    predictionAccuracy: 1, // Default olarak burası 1 olacak
    multipleComparisonValue: 0,
    pairwiseComparisonValue: 0,
    category: 0,
  })
  const [maxHeight, setMaxHeight] = useState('calc(100vh - 330px)')

  const updateHeight = () => {
    setMaxHeight(`${window.innerHeight - 355}px`)
  }

  useEffect(() => {

    // fetch

    // İlk yükleme sırasında yükseklik hesaplaması yap
    updateHeight()

    // Pencere boyutu değiştiğinde yükseklik güncelle
    window.addEventListener('resize', updateHeight)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', updateHeight)
    }
  }, [])

  useEffect(() => {
    const targetNode = document.getElementById('kt_app_sidebar')
    if (!targetNode) return

    const resizeObserver = new ResizeObserver(() => {
      updateHeight()
    })

    resizeObserver.observe(targetNode)

    return () => {
      resizeObserver.disconnect()
    }
  }, [])
  const [currentHeader, setCurrentHeader] = useState('Best ISPP')
  const containerRef = useRef(null)
  const bestIsppRef = useRef(null)
  const advancedRef = useRef(null)

  // Scroll olayını dinlemek için useLayoutEffect kullanıyoruz
  useLayoutEffect(() => {
    const container = containerRef.current
    const handleScroll = () => {
      if (!container || !bestIsppRef.current || !advancedRef.current) return
      // Container ve diğer başlıkların konumlarını alıyoruz
      const containerTop = container.getBoundingClientRect().top
      const advancedTop = advancedRef.current.getBoundingClientRect().top

      // Kaydırma ile başlıkları değiştiriyoruz
      if (advancedTop <= containerTop + 50) {
        setCurrentHeader('Other ISPP')
      } else {
        setCurrentHeader('Best ISPP')
      }
    }

    if (container) {
      container.addEventListener('scroll', handleScroll)
      console.log('Scroll event listener added')
    }
  }, [geneData]) // useLayoutEffect yalnızca bir kez çalışacak şekilde

  const handleSort = (column) => {
    setSortStates((prevState) => {
      const newStates = { ...prevState }

      // Tıklanan kolonun durumunu döngüsel olarak değiştir (0 → 1 → 2 → 1)
      newStates[column] = prevState[column] === 2 ? 1 : prevState[column] + 1

      // Diğer kolonları sıfırla
      Object.keys(newStates).forEach((key) => {
        if (key !== column) {
          newStates[key] = 0
        }
      })

      return newStates
    })
  }

  const calculateGradientBackground = (geneScore, maxGeneScore, categoryColor) => {
    if (geneScore < 0) {
      return '#d3d3d3' // Gri renk
    }
    if (categoryColor === undefined) {
      return '#000000' // Gri renk
    }
    // Minimum renkler
    const minimumColors = {
      A: [253, 235, 236], // Kırmızı (en düşük)
      B: [172, 189, 232], // Mavi (en düşük)
      C: [234, 208, 173], // Sarı (en düşük)
      D: [198, 221, 238], // Açık mavi (en düşük)
    }

    // Kategoriye göre minimum renkleri al
    const category = Object.keys(categoryColors).find(
      (key) => categoryColors[key].toLowerCase() === categoryColor.toLowerCase()
    )
    const [minR, minG, minB] = minimumColors[category] || [0, 0, 0]

    // Extract base color (R, G, B) from the category color
    const r = parseInt(categoryColor.slice(1, 3), 16)
    const g = parseInt(categoryColor.slice(3, 5), 16)
    const b = parseInt(categoryColor.slice(5, 7), 16)

    // Normalize geneScore to range between 0 and 1
    const normalizedScore = Math.max(0, Math.min(1, geneScore / maxGeneScore))

    // Hesaplanan rengi canlılık ekleyerek oluştur
    const adjustedR = Math.round(minR + (r - minR) * normalizedScore)
    const adjustedG = Math.round(minG + (g - minG) * normalizedScore)
    const adjustedB = Math.round(minB + (b - minB) * normalizedScore)

    return `rgb(${adjustedR}, ${adjustedG}, ${adjustedB})`
  }
  function sortDataByGeneScore(data, ascending = true) {
    return data
      .slice()
      .sort((a, b) => (ascending ? a.geneScore - b.geneScore : b.geneScore - a.geneScore))
  }

  function sortDataAlphabetically(data, ascending = true) {
    return data
      .slice()
      .sort((a, b) => (ascending ? a.ispp.localeCompare(b.ispp) : b.ispp.localeCompare(a.ispp)))
  }

  function sortDataByMultipleComparisonValue(data, ascending = true) {
    if (!data) return
    return data
      .slice()
      .sort((a, b) =>
        ascending
          ? a.kruskalInvPvalue - b.kruskalInvPvalue
          : b.kruskalInvPvalue - a.kruskalInvPvalue
      )
  }

  function sortDataByPairwiseComparisonValue(data, ascending = true) {
    return data
      .slice()
      .sort((a, b) =>
        ascending
          ? a.wilcoxonInvPvalue - b.wilcoxonInvPvalue
          : b.wilcoxonInvPvalue - a.wilcoxonInvPvalue
      )
  }
  function sortDataByCategory(data, ascending = true) {
    const categoryOrder = {
      B: 0, // Amino Acid Conservation
      A: 1, // Nucleotide Conservation
      C: 2, // Multi-Parameter
      D: 3, // Multi-Score
    }

    return data.slice().sort((a, b) => {
      const aOrder = categoryOrder[a.category] ?? Infinity // Tanımsız kategoriler sona gider
      const bOrder = categoryOrder[b.category] ?? Infinity

      return ascending ? aOrder - bOrder : bOrder - aOrder
    })
  }

  useEffect(() => {
    if (!geneData) return

    let sortedData = geneData.slice()
    let sortedBestIspps = bestIspps.slice()
    // Sıralama durumlarına göre işlem yap
    switch (true) {
      case sortStates.ISPP === 1:
        sortedData = sortDataAlphabetically(sortedData)
        sortedBestIspps = sortDataAlphabetically(sortedBestIspps)
        break

      case sortStates.ISPP === 2:
        sortedData = sortDataAlphabetically(sortedData, false)
        sortedBestIspps = sortDataAlphabetically(sortedBestIspps, false)
        break

      case sortStates.predictionAccuracy === 1:
        sortedData = sortDataByGeneScore(sortedData, false)
        sortedBestIspps = sortDataByGeneScore(sortedBestIspps, false)
        break

      case sortStates.predictionAccuracy === 2:
        sortedData = sortDataByGeneScore(sortedData)
        sortedBestIspps = sortDataByGeneScore(sortedBestIspps)
        break

      case sortStates.multipleComparisonValue === 2:
        sortedData = sortDataByMultipleComparisonValue(sortedData)
        sortedBestIspps = sortDataByMultipleComparisonValue(sortedBestIspps)
        break

      case sortStates.multipleComparisonValue === 1:
        sortedData = sortDataByMultipleComparisonValue(sortedData, false)
        sortedBestIspps = sortDataByMultipleComparisonValue(sortedBestIspps, false)
        break

      case sortStates.pairwiseComparisonValue === 2:
        sortedData = sortDataByPairwiseComparisonValue(sortedData)
        sortedBestIspps = sortDataByPairwiseComparisonValue(sortedBestIspps)
        break

      case sortStates.pairwiseComparisonValue === 1:
        sortedData = sortDataByPairwiseComparisonValue(sortedData, false)
        sortedBestIspps = sortDataByPairwiseComparisonValue(sortedBestIspps, false)
        break

      case sortStates.category === 1:
        sortedData = sortDataByCategory(sortedData)
        sortedBestIspps = sortDataByCategory(sortedBestIspps)
        break

      case sortStates.category === 2:
        sortedData = sortDataByCategory(sortedData, false)
        sortedBestIspps = sortDataByCategory(sortedBestIspps, false)
        break

      default:
        sortedData = sortDataByGeneScore(sortedData, false)
        sortedBestIspps = sortDataByGeneScore(sortedBestIspps, false)
        break
    }
    setGeneData(sortedData)
    setBestIspps(sortedBestIspps)
  }, [sortStates])

  const categoryColors = {
    A: '#E59B39',
    B: '#3C8BC6',
    C: '#101F3D',
    D: '#E93645',
  }

  const categorizeISPPs = (data) => {
    const categorizedData = { A: [], B: [], C: [], D: [] }

    data.forEach((item) => {
      for (const [category, isppList] of Object.entries(categoryMap)) {
        if (isppList.includes(item.ispp)) {
          categorizedData[category].push(item)
          break
        }
      }
    })

    return categorizedData
  }
  const downloadTSV = async (type = 'gene') => {
    Swal.fire({
      title: 'Downloading...',
      html: 'Please wait while we prepare the file for download.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })

    try {
      const response = await axios.get(
        `${serviceUrl}/download_data/${type === 'gene' ? 'gene_ispp' : 'gene_variants'
        }/${gene.toUpperCase()}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*',
          },
          responseType: 'blob',
        }
      )
      const blob = new Blob([response.data], { type: 'application/gzip' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = type === 'gene' ? `${gene}_gene.tsv.gz` : `${gene}_variant_VAMPP.tsv.gz`
      link.click()
      window.URL.revokeObjectURL(link.href)
      Swal.close()
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while downloading the file.',
        confirmButtonText: 'Close',
      })
    }
  }
  const handleClickISPP = async (ispp) => {
    setPlotError(null)
    setViolinData(null)
    setSelectedISPP(ispp)
    try {
      const clinvar = await axios.get(
        `${serviceUrl}/clinvar/gene/${gene.toLocaleUpperCase()}/${ispp}`,
        {
          headers: { 'Content-Type': 'application/json', Accept: '*' },
        }
      )
      setViolinData(clinvar.data)
      setSelectedISPP(ispp)
    } catch (error) {
      setPlotError('Error fetching data for ISPP')
    }
  }

  const fetchGeneData = async () => {
    if (!gene) return
    setLoading(true)
    try {
      const checkGene = await axios.get(`https://rest.ensembl.org/xrefs/symbol/homo_sapiens/${gene}?content-type=application/json;external_db=HGNC`)
      if (checkGene?.data?.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Gene does not exist',
          confirmButtonText: 'Back to Search',
        }).then(() => navigate('/'))
        return
      }

      const response = await axios.get(
        `${serviceUrl}/genescores/gene/${gene}`,
        {
          headers: { 'Content-Type': 'application/json', Accept: '*' },
        }
      )
      const geneDetail = await axios.get(
        `${serviceUrl}/gene_information/${gene}`)
      setGeneDetails(geneDetail.data)

      const data = response.data
      if (data.length === 0) {
        let resultArray = [];
        const bestIspp = [
          {
            ispp: 'MetaRNN',
            category: 'D'
          },
          {
            ispp: 'ClinPred',
            category: 'D'
          },
          {
            ispp: 'BayesDel_addAF',
            category: 'D'
          },
          {
            ispp: 'VEST4',
            category: 'D'
          },
          {
            ispp: 'AlphaMissense',
            category: 'C'
          },
          {
            ispp: 'BayesDel_noAF',
            category: 'D'
          },
          {
            ispp: 'MetaLR',
            category: 'D'
          },
          {
            ispp: 'VARITY_R',
            category: 'C'
          },
        ]
        const bestIsppSet = new Set(bestIspp.map(item => item.ispp));
        // '',
        // '',
        // '',
        // '',
        // '',
        // '',
        // ''
        const bestIsppResultArray = bestIspp.map((ispp) => {
          return {
            ispp: ispp.ispp,
            category: ispp.category,
            kruskalPvalue: null,
            wilcoxonPvalue: null,
            kruskalInvPvalue: null,
            wilcoxonInvPvalue: null,
            geneScore: null
          }
        })
        for (const [category, values] of Object.entries(categoryMap)) {
          for (const ispp of values) {
            if (!bestIsppSet.has(ispp)) { // Eğer bestIspp içinde yoksa ekle
              resultArray.push({
                ispp: ispp,
                category: category,
                kruskalPvalue: null,
                wilcoxonPvalue: null,
                kruskalInvPvalue: null,
                wilcoxonInvPvalue: null,
                geneScore: null
              });
            }
          }
        }

        resultArray.sort((a, b) => a.ispp.localeCompare(b.ispp));

        setGeneData(resultArray);
        setBestIspps(bestIsppResultArray);
        setError('empty');
        return;
      }
      const categorizedData = data.map((item) => {
        let category = null
        for (const [key, values] of Object.entries(categoryMap)) {
          if (values.includes(item.ispp)) {
            category = key
            break
          }
        }

        return { ...item, category }
      })
      // add category key to data
      data.forEach((item) => {
        let category = null
        for (const [key, values] of Object.entries(categoryMap)) {
          if (values.includes(item.ispp)) {
            category = key
            break
          }
        }
        item.category = category
      })
      const filteredData = categorizedData
        .filter((item) => item.geneScore > 0)
        .sort((a, b) => b.geneScore - a.geneScore)
        .slice(0, 8)

      setBestIspps(filteredData)

      const isppValuesInFilteredData = filteredData.map((item) => item.ispp)

      const updatedCategorizedData = categorizedData.filter(
        (item) => !isppValuesInFilteredData.includes(item.ispp)
      )

      setGeneData(sortDataByGeneScore(updatedCategorizedData, false))
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error fetching data for gene "${gene}"`,
        confirmButtonText: 'Back to Search',
      }).then(() => navigate('/'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchGeneData()
  }, [gene])
  useEffect(() => {
    if (geneData) {
      // const categorizedData = categorizeISPPs(geneData)
      // setCategorizedGeneData(sortDataByGeneScore(categorizedData, false))
    }
  }, [geneData])
  console.log(currentHeader)
  if (loading) {
    return (
      <div className='card'>
        <div className='card-body'>
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className='card search-detail-card'>
      <PageTitle breadcrumbs={[]}>{gene}</PageTitle>
      <div className='card-body pt-2'>
        {geneData && (
          <div>
            <div className='search-detail-header justify-content-between w-full'>
              <div className='mt-2' style={{
                maxWidth: '100%',
                overflow: 'auto',
              }}>
                <div className='border border-gray-300 bordered-box-wrapper border-dashed rounded  gap-5  py-3 px-4 me-7 '>
                  <div
                    className='bordered-box'
                  >
                    <div className='fw-bold text-gray-500 fs-8'>Approved Symbol</div>
                    <div className='fs-7 text-gray-800 fw-bolder' style={{
                      fontStyle: 'italic'
                    }}>{geneDetails?.approved_symbol || ''}</div>
                  </div>
                  {geneDetails?.alias_symbols && (
                    <div
                      className='bordered-box'

                    >
                      <div className='fw-bold text-gray-500 fs-8'>Alias Symbols</div>
                      <div className='fs-7 text-gray-800 fw-bolder' style={{
                        fontStyle: 'italic'
                      }}>{geneDetails?.alias_symbols.join(",")} </div>
                    </div>
                  )}
                  {geneDetails?.hgnc_id && (
                    <div
                      className='bordered-box'

                    >
                      <div className='fw-bold text-gray-500 fs-8'>HGNC ID</div>
                      <div className='fs-7 text-gray-800 fw-bolder'>{geneDetails?.hgnc_id} </div>
                    </div>
                  )}
                  {geneDetails?.refseq_id && (
                    <div
                      className='bordered-box'

                    >
                      <div className='fw-bold text-gray-500 fs-8'>Refseq ID</div>
                      <div className='fs-7 text-gray-800 fw-bolder'>{geneDetails?.refseq_id} </div>
                    </div>
                  )}
                  <div>
                    <div className='fw-bold text-gray-500 fs-8'>NCBI</div>
                    <div className='fs-6 text-gray-800 fw-bolder'>
                      {geneDetails?.ncbi_gene_id}
                    </div>
                  </div>
                </div>


              </div>

              {/* {bestIspps.length === 8 && (
                <p className='text-left mt-2'>
                  For gene <label className='fst-italic'> {gene} </label> , these are the most
                  accurate ISPPs based on VAMPP-score metrics.
                  <br /> We recommend using these for the in-silico interpretation of the variants
                  in gene <label className='fst-italic'> {gene} </label>. Please check About section
                  for more info on our metrics.
                </p>
              )}
              {bestIspps.length === 0 && (
                <p className='text-left mt-2'>
                  For gene <label className='fst-italic'> {gene} </label>, it has been evaluated
                  that there are not specific ISPPs with prediction accuracy, <br />
                  which might be due to limited data availability. However, these are the most
                  accurate ISPPs based on our metrics, for both exome- and Mendeliome-wide. We
                  recommend using these for the in-silico interpretation of the variants in the gene{' '}
                  <label className='fst-italic'> {gene} </label> when in doubt. Please check About
                  section for more info on our metrics.
                </p>
              )}
              {bestIspps.length < 8 && bestIspps.length > 0 && (
                <p className='text-left mt-2'>
                  For gene <label className='fst-italic'> {gene} </label>, these are the most
                  accurate ISPPs based on VAMPP-score metrics. <br />
                  We recommend using these for the in-silico interpretation of the variants in gene{' '}
                  <label className='fst-italic'> {gene} </label>. Please check About section for
                  more info on our metrics.
                </p>
              )} */}
              <div className='advanced-filter '>
                <button
                  className='btn btn-primary  my-2  dropdown-toggle'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <i className='fa fa-download mx-2' />
                  Download as TSV
                </button>
                <div className='dropdown-menu' style={{ minWidth: '200px' }}>
                  <div className='px-7 pt-4 pb-2  d-flex flex-column gap-4'>
                    <span
                      className=' cursor-pointer text-gray-500 fs-4 border-bottom py-2'
                      onClick={() => downloadTSV('gene')}
                    >
                      Gene Results
                      {/* make info badge                       */}
                      <i
                        className='fa fa-info-circle mx-2'
                        data-tooltip-id='desc-tooltip'
                        data-tooltip-html={`file contains VAMPP-score parameters for each ISPP.`}
                        style={{ fontSize: '12px', color: 'gray' }}
                      ></i>
                    </span>
                    <span
                      className=' cursor-pointer text-gray-500 fs-4'
                      onClick={() => downloadTSV('variant')}
                    >
                      Variant Results
                      <i
                        className='fa fa-info-circle mx-2'
                        data-tooltip-id='desc-tooltip'
                        data-tooltip-html={`file contains ISPP scores sourced from dbNSFP and VAMPP scores for all variants associated with the gene of interest.`}
                        style={{ fontSize: '12px', color: 'gray' }}
                      ></i>
                    </span>
                  </div>
                </div>
              </div>

            </div>
            {error === 'empty' && (
              <ul className='mt-2'>
                <li>
                  For {gene}, no ISPPs showed significant performance results or were excluded from performance calculations due to limited reported variants in ClinVar.
                </li>
                <li>
                  For further analysis, we recommend using the best-performing ISPPs as a general reference for exome- and Mendeliome-wide variant interpretation.
                </li>
              </ul>
            )}
            <div
              style={{
                overflowX: 'auto',
                overflowY: 'hidden',
                // Yatay kaydırma için
                width: '100%', // Ekran genişliğine göre
                whiteSpace: 'nowrap', // İçeriği aynı satırda tutmak için
              }}
            >
              <div className='d-flex justify-content-end mt-1'>
                <div
                  className='col-md-12'
                  style={{
                    backgroundColor: 'white',
                    padding: '15px',
                    textAlign: 'left',
                    margin: '5px 10px',
                    position: 'relative',
                    fontWeight: '500',
                    borderLeft: `10px solid white`,
                    borderRight: `10px solid white`,
                    borderBottom: `1px solid #f0f0f0`,
                    borderRadius: '10px',
                    cursor: 'pointer',
                    width: '100%',
                  }}
                >
                  <div
                    className='table-header-wrapper d-flex justify-content-between'
                    style={{
                      marginLeft: '35px',
                    }}
                  >
                    {[
                      { label: 'ISPP', key: 'ISPP', desc: ' in silico pathogenicity predictor' },
                      { label: 'Prediction Accuracy', key: 'predictionAccuracy', desc: 'Measures ISPP performance for each gene. Lower scores indicate weaker accuracy, <br> while negative scores signal severe misclassification between benign and pathogenic variants.' },
                      {
                        label: 'Multiple Comparison (1-p)', key: 'multipleComparisonValue', desc: ' Evaluates how well an ISPP differentiates between variant groups <br>(pathogenic, benign, and unknown). Higher values indicate better performance.',
                      },
                      { label: 'Pairwise Comparison (1-p)', key: 'pairwiseComparisonValue', desc: 'Evaluates how well an ISPP distinguishes between pathogenic and <br> benign variant groups. Higher values indicate better performance.' },
                      { label: 'Category', key: 'category', desc: 'ISPP classification based on methodology: Nucleotide Conservation for evolutionary sequence conservation,<br> Amino Acid Conservation to evaluate protein changes, Multi-Parameter integrates diverse data, and Multi-Score combines <br> multiple predictors to improve accuracy.' },
                    ].map((column) => (
                      <div
                        className='col-md-2 table-header'
                        key={column.key}
                        onClick={() => handleSort(column.key)}
                      >

                        <strong>
                          {column.key === 'ISPP' && (
                            <div className="" style={{
                              minWidth: '25px',
                              display: 'inline-block',
                            }}> </div>
                          )}
                          <img
                            src='/sort-triangle.png'
                            alt='sort-icon'
                            style={{
                              width: '12px',
                              height: '12px',
                              marginRight: '5px',
                              transform: sortStates[column.key] === 1 ? 'rotate(90deg)' : 'none',
                              visibility: sortStates[column.key] ? 'visible' : 'hidden',
                            }}
                          />
                          {column.label}{' '}
                          <i
                            className='fa fa-info-circle mx-2'
                            data-tooltip-id='desc-tooltip'
                            data-tooltip-place='bottom'
                            data-tooltip-html={column.desc}
                            style={{ fontSize: '12px', color: 'gray' }}
                          ></i>
                        </strong>
                      </div>
                    ))}
                    <div className='position-sticky'>
                      {sortStates.predictionAccuracy !== 1 && (
                        <button
                          className='bg-white position-sticky  back-to-default-sort'
                          style={{
                            right: '15px',
                            border: '1px solid #d5d4d4',
                            borderRadius: '5px',
                            top: '0px',
                          }}
                          data-tooltip-id='desc-tooltip'
                          data-tooltip-html={`Reset to default sort`}
                          onClick={() =>
                            setSortStates({
                              ISPP: 0,
                              predictionAccuracy: 1, // Default olarak burası 1 olacak
                              multipleComparisonValue: 0,
                              pairwiseComparisonValue: 0,
                              category: 0,
                            })
                          }
                        >
                          <i className='fa fa-repeat'></i>
                        </button>
                      )}
                    </div>
                  </div>

                </div>
              </div>

              {bestIspps.length > 0 && (
                <div
                  style={{ maxHeight: maxHeight, display: 'flex', flexDirection: 'column', minWidth: '1200px', overflowY: 'auto', overflowX: 'hidden' }}
                  className='  rounded mt-3'
                  ref={containerRef}
                >
                  <div className="mt-1">
                    <div className="d-flex mb-4 position-relative">
                      <div className=' position-relative  sticky-header' style={{
                        borderRight: '4px solid #2ecc71',
                        borderRadius: '6px',
                        height: 'auto',
                      }}>
                        <span className="list-title  fw-bold fs-2 position-sticky" style={{
                          top: 0,
                        }} >   Best ISPP </span>
                      </div>
                      <div
                        style={{
                          width: '97.5%',
                          marginLeft: 'auto',
                        }}
                        ref={bestIsppRef}
                      >
                        {bestIspps.map((item, index) => (
                          <div key={index} className='' style={{
                            cursor: 'pointer',
                          }}
                          >
                            <div
                              style={{
                                borderLeft: `30px solid ${item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category]}`,
                                borderRight: `10px solid ${item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category]}`,
                                borderBottom: `1px solid #f0f0f0`,
                                borderTop: `1px solid #f0f0f0`,
                              }}
                              className='list-wrapper'
                              onClick={() => {
                                if (error === 'empty') return;
                                handleClickISPP(item.ispp)
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                }}
                                className='col-md-2 d-flex'
                              >
                                <i className={index < 3 ? 'fa fa-trophy mx-2' : 'fa fa-award mx-2'}
                                  data-tooltip-id='desc-tooltip'
                                  data-tooltip-html={`Ranked #${index + 1} by VAMPP-score for <i>${gene}</i> variants based on accuracy.`}
                                  style={{ fontSize: '20px', color: 'gold' }}></i>

                                <div
                                  style={{
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                  }}
                                  className='ispp-cell'

                                >
                                  <span
                                    data-tooltip-id='desc-tooltip'
                                    data-tooltip-place='right'
                                    data-tooltip-html={isppDescriptions[item?.ispp]}
                                  >
                                    {userReadableISPPMap[item?.ispp] || item?.ispp}
                                  </span>
                                </div>
                              </div>
                              <span className='d-block mb-2  fw-bold fs-7 mt-4 col-md-2 list-cell'>
                                {item.geneScore?.toFixed(3) || '-'}
                              </span>
                              <span
                                className='d-block fs-7   mb-2 col-md-2 list-cell'
                                style={{
                                  fontWeight: '600',

                                }}
                              >
                                {item.kruskalInvPvalue?.toFixed(3) || '-'}{' '}
                              </span>
                              <span
                                className='d-block fs-7   col-md-2 list-cell'
                                style={{
                                  fontWeight: '600',

                                }}
                              >
                                {item.wilcoxonInvPvalue?.toFixed(3) || '-'}
                              </span>
                              <span className='d-block fs-7   col-md-2 list-cell-mid'>
                                <label className="badge badge-pill  text-white
                                " style={{
                                    backgroundColor: item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category],


                                  }}>
                                  {item.category === 'A' && 'Nucleotide Conservation'}
                                  {item.category === 'B' && 'Amino Acid Conservation'}
                                  {item.category === 'C' && 'Multi-Parameter'}
                                  {item.category === 'D' && 'Multi-Score'}
                                </label>
                              </span>

                              <Tooltip id='box-tooltip' place={'right'} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='mt-1'>
                    <div className='mb-4 d-flex  '>
                      <div className=' position-relative sticky-header' style={{
                        borderRight: '4px solid #EBEDF1',
                        borderRadius: '6px',
                        height: 'auto',
                      }}>
                        <span className="list-title  fw-bold fs-2 position-sticky" style={{
                          top: 0,
                        }} >   Other ISPP </span>
                      </div>
                      <div
                        style={{
                          width: '97.5%',
                          marginLeft: 'auto',
                        }}

                        ref={advancedRef}
                      >
                        {geneData.map((item, index) => {
                          // if (hidenegative && item.geneScore < 0) return null
                          return (
                            <>
                              <div
                                key={index}
                                style={{
                                  cursor: 'pointer',
                                }}
                              >
                                <div
                                  style={{
                                    borderLeft: `30px solid ${item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category]}`,
                                    borderRight: `10px solid ${item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category]}`,
                                    borderBottom: `1px solid #f0f0f0`,
                                    borderTop: `1px solid #f0f0f0`,

                                  }}
                                  className='list-wrapper'
                                  onClick={() => {
                                    if (error === 'empty') return;
                                    handleClickISPP(item.ispp)
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: 'bold',
                                    }}
                                    className='col-md-2 d-flex'
                                  >
                                    <div
                                      style={{
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        marginLeft: '25px',
                                      }}
                                      className='ispp-cell'

                                    >
                                      <span
                                        data-tooltip-id='desc-tooltip'
                                        data-tooltip-place='right'
                                        data-tooltip-html={isppDescriptions[item?.ispp]}
                                      >
                                        {userReadableISPPMap[item?.ispp] || item?.ispp}
                                      </span>
                                    </div>
                                  </div>
                                  <span className='d-block fw-bold col-md-2 mb-2 list-cell'>
                                    {item.geneScore?.toFixed(3) || '-'}
                                  </span>
                                  <span
                                    className='d-block col-md-2 mb-2 list-cell'
                                    style={{
                                      fontWeight: '600',
                                    }}
                                  >
                                    {' '}
                                    {item.kruskalInvPvalue?.toFixed(3) || '-'}{' '}
                                  </span>
                                  <span
                                    className='d-block col-md-2 list-cell'
                                    style={{
                                      fontWeight: '600',
                                    }}
                                  >
                                    {' '}
                                    {item.wilcoxonInvPvalue?.toFixed(3) || '-'}
                                  </span>
                                  <span className='d-block fs-7   col-md-2 list-cell-mid'>
                                    <label className="badge badge-pill  text-white
                                " style={{
                                        backgroundColor: item.geneScore < 0 ? '#d3d3d3' : categoryColors[item.category],
                                      }}>
                                      {item.category === 'A' && 'Nucleotide Conservation'}
                                      {item.category === 'B' && 'Amino Acid Conservation'}
                                      {item.category === 'C' && 'Multi-Parameter'}
                                      {item.category === 'D' && 'Multi-Score'}
                                    </label>
                                  </span>
                                </div>
                              </div>
                            </>
                          )
                        })}
                      </div>

                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}
        <Modal
          isOpen={selectedISPP === null ? false : true}
          modalTitle={selectedISPP}
          onClose={() => setSelectedISPP(null)}
        >
          {plotError && <div className='text-center py-2 text-danger'> {plotError} </div>}
          {!violinData && !plotError && (
            <div className='d-flex justify-content-center py-2'>
              <div className='spinner-border text-center' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          )}
          {violinData && <ViolinPlot type='gene' ispp={selectedISPP} gene={gene} data={violinData} />}
        </Modal>
      </div>
      <Tooltip id='desc-tooltip' place={'right'} />
      <Tooltip id='box-tooltip' place={'right'} />
      <Tooltip id='advanced-tooltip' place={'right'} />

    </div >
  )
}

export default GeneSearchPage
